const isNotEmpty = (v) => v.trim();

const getAmount = (currentAmount) => currentAmount * 1;

export { isNotEmpty, getAmount };
